import { ChakraProvider, createSystem, defaultConfig, defineConfig, defineSlotRecipe } from "@chakra-ui/react";
import { tableAnatomy } from "@chakra-ui/react/anatomy";
import type { ReactNode } from "react";
import { Toaster } from "./toaster";

/**
 * Chakra's default theme, with the few things the app decides once rather than
 * page by page.
 *
 * Table column headers: small, spaced capitals in the muted colour -- the same
 * voice as the card and section labels, so a header reads as a label for the
 * column rather than as the first row of data. Set here so every table gets it,
 * including the ones not written yet; a header that needs otherwise (the
 * programme matrix's rotated activity titles) still says so on itself.
 */
const config = defineConfig({
  theme: {
    slotRecipes: {
      // Merged into Chakra's own table recipe, not a replacement for it: only
      // what is named here changes.
      table: defineSlotRecipe({
        slots: tableAnatomy.keys(),
        base: {
          columnHeader: {
            fontSize: "xs",
            fontWeight: "medium",
            textTransform: "uppercase",
            letterSpacing: "0.14em",
            color: "fg.muted",
          },
        },
      }),
    },
  },
});

const system = createSystem(defaultConfig, config);

export function Provider({ children }: { children: ReactNode }) {
  return (
    <ChakraProvider value={system}>
      {children}
      {/* Mounted once, above every page: a message about something that just
          happened should not depend on which page is open, nor scroll away
          with it. */}
      <Toaster />
    </ChakraProvider>
  );
}
